<router-outlet></router-outlet>

<!-- Modal de imágenes -->
<div id="myModal" class="modal">
    <!-- Botón de cerrado -->
    <span class="close" onclick="document.getElementById('myModal').style.display='none'">&times;</span>
    <!-- Contenido del modal -->
    <img class="modal-content" id="img01">
</div>
